import { render, staticRenderFns } from "./KSkeleton.vue?vue&type=template&id=0ca33984&"
import script from "./KSkeleton.vue?vue&type=script&lang=js&"
export * from "./KSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./KSkeleton.vue?vue&type=style&index=0&id=0ca33984&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports